export default {
  apiUrl: "https://www.minhahora.entreoutros.com/v3",
};
